import React from 'react';
import './App.css'
import { useState, useEffect } from 'react';

import './App.css'; 

import { fetchAuthSession } from 'aws-amplify/auth';

import Certificate from './Certificate';
import ReactDOM from 'react-dom/client';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import { signOut } from "aws-amplify/auth"
import BusinessPage from './BusinessPage';
import VRPurchasePageBusiness from './VRPurchasePageBusiness';
import ComingSoon from './ComingSoon';








const Dashboard = () => {

const navigate = useNavigate();

const get_user_detail = async()=>{
 const {family_name, given_name} = await fetchUserAttributes();
 setGivenName(given_name)
 setFamilyName(family_name)
}
 

  const [givenName, setGivenName] = useState([]);
  const [familyName, setFamilyName] = useState([]);
  const [inputLicnese, setInputLicense] = useState();

  // Mail list csv upload
  const [emailLists, setEmailLists] = useState({
  drivingProG: [],
  drivingBlack: [],
  awarePro: [],
  awareRoad: [],
  awareAllRoad: [],
  aware: [],
  processSafety: [],
});

  const handleCsvUpload = (event, type) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const emails = text.split(/[\n,]+/)
      .filter((email) => email);
      console.log(emails)
      setEmailLists((prev) => ({
        ...prev,
        [type]: emails,
      }));
    };
    reader.readAsText(file);
  };

  const handleEmailChange = (type, index, newEmail) => {
    setEmailLists((prev) => {
      const updatedEmails = [...prev[type]];
      updatedEmails[index] = newEmail;
      return { ...prev, [type]: updatedEmails };
    });
  };



// submitting the form
  const handleSend =  async(license, game_name, email) => {
    console.log("value of email", email)
    if (!email)
      
    {
      console.log(email)
      alert("Please provide a valid email address.")
      return;
    }
    const payLoad = {
      entries: [
        {
          "game_name": game_name,
          "license": license,
          "email": email,
        },
      ],
    };
   
    console.log("value of payload", payLoad)

    const apiUrl = 'https://8tozabr24m.execute-api.me-south-1.amazonaws.com/developed/send_share_email';

    try {
      setLoading(true);
      setError(null);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payLoad),
      });

      console.log(response)

      if (!response.ok) {
        throw new Error(`Failed to send: ${response.statusText}`);
      }

      alert('Email sent successfully!');
    } catch (err) {
      console.error('Error:', err);
      setError(err.message || 'Something went wrong');
      alert('Failed to send email.');
    } finally {
      setLoading(false);
    }
    console.log("Emails:", email);
    console.log("Game Name:", game_name);
    console.log("License shared:", license);
  };
  

  const handleSendAll =  async(gameType, type) => {
      const emails = emailLists[type];
      const allEntries = [];

      gameType.forEach ((license, index) =>
      {
          console.log(license.game_name)
        if (license.game_name && emails[index]){
        const payLoad = {
          game_name: license.game_name,
          license: license.license,
          email: emails[index],
        };
      
        allEntries.push(payLoad)
      }
      })
        
        const finalPayLoad ={
          entries: allEntries,
        };
      
    console.log("email list", allEntries)
    

    const apiUrl = 'https://8tozabr24m.execute-api.me-south-1.amazonaws.com/developed/send_share_email';

    

    try {
      setLoading(true);
      setError(null);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(finalPayLoad),
      });

      console.log(response)

      if (!response.ok) {
        throw new Error(`Failed to send: ${response.statusText}`);
      }
      

      const data =  response.json();
      console.log('Success:', data);
      alert('Email sent successfully!');
    } catch (err) {
      console.error('Error:', err);
      setError(err.message || 'Something went wrong');
      alert('Failed to send email.');
    } finally {
      setLoading(false);
    }
  
  
  };
// active tab
  const [activeTab, setActiveTab] = useState('pc');

// pages status
  const [activePage, setActivePage] = useState('');

//   license
  const [licenses, setLicenses] = useState({
      "Life-Saving Rules Pro": 0,
      "Life-Saving Rules Road": 0,
      "Life-Saving Rules Aware": 0,
      "Driving Pro Blacktop":0,
      "Driving Pro Graded Road": 0,
      "Driving Aware All Roads": 0,
      "Process Safety": 0,

  });




  const [companyLicense, setCompanyLicense] = useState("");
  const [licenseData, setLicenseData] = useState("");
  
  const [VRLicenseData, setVRLicenseData] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
//   renewing licenses
  const [renewSelection, setRenewSelection] = useState({});
//   pin code check
  const [pin, setPin] = useState('');
//   available games for renewal
  const [availableGames, setAvailableGames] = useState([]);

//   games certificates
  const [completedGames, setCompletedGames] = useState([]);
  // Set discount
  const [discount, SetDiscount]=useState(0);


    // fetch user license
  useEffect(() => {
    const fetchLicenseData = async () => {
      const session = await fetchAuthSession();
      const jwtToken = session.tokens.idToken;

        
      try {
        const response = await fetch('https://9xpzjng1i1.execute-api.me-south-1.amazonaws.com/developed/get_user_licenses',
          {
            method: 'GET',
            mode: 'cors',
            headers: 
        {
            'Authorization': `Bearer ${jwtToken}`,  
            'Content-Type': 'application/json',
          


        }
      });
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const dataArray = await response.json();

        if (dataArray) {
          const extract_data = dataArray.map(({ game_name, license, game_play, active, pass, expiration_date, pass_date }) => ({
            game_name,
            license,
            game_play,
            active,
            pass, 
            expiration_date,
            pass_date
          }))
          setLicenseData(extract_data);
        
        } else {
          setError('License not found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLicenseData();
  }, []);


// fetch company license for sharing
  useEffect(() => {
    const fetchCompanyLicense = async () => {
      try {

        
        const session = await fetchAuthSession();
        const jwtToken = session.tokens.idToken;
        


        const response = await fetch('https://9rktw15s9b.execute-api.me-south-1.amazonaws.com/developed/fetch_share_license',
        {
          method: 'GET',
          mode: 'cors',
          headers: 
      {
          'Authorization': `Bearer ${jwtToken}`,  
          'Content-Type': 'application/json'
      }
    });

      console.log(response)
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const dataArray = await response.json();

        if (dataArray) {
          const extract_data = dataArray.map(({game_name, license, activation}) => ({
            game_name,
            license,
            activation
          }))
      
          setCompanyLicense(extract_data);
        } else {
          setError('License not found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyLicense();
  }, []);



// Fetch VR License
  useEffect(() => {
    const fetchVRLicenseData = async () => {
      const session = await fetchAuthSession();
      const jwtToken = session.tokens.idToken;

        
      try {
        const response = await fetch('https://gfpsnzc5ga.execute-api.me-south-1.amazonaws.com/developed/get_vr_licenses',
          {
            method: 'GET',
            mode: 'cors',
            headers: 
        {
            'Authorization': `Bearer ${jwtToken}`,  
            'Content-Type': 'application/json',
          


        }
      });
        console.log(response)
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const dataArray = await response.json();

        if (dataArray) {
          const extract_data_vr = dataArray.map(({ game_name, license, game_play, active, pass, expiration_date, pass_date }) => ({
            game_name,
            license,
            game_play,
            active,
            pass, 
            expiration_date,
            pass_date
          }))
          setVRLicenseData(extract_data_vr);
        
        } else {
          setError('License not found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchVRLicenseData();
  }, []);



const HandleSignOut = async () => {

      try {
        await signOut();
        console.log("signout was clicked")
          navigate('/');  // Navigate after a slight delay
      } catch (error) {
        console.error('Error signing out:', error);
      }
    };
  

// share license 
const [awarePro, setAwarePro] = useState([]);
const [awareRoad, setAwareRoad] = useState([]);
const [awareAllRoad, setAwareAllRoad] = useState([]);
const [drivingProG, setDrivingProG] = useState([]);
const [drivingBlack, setDrivingBlack] = useState([]);
const [aware, setAwareRule] = useState([]);
const [processSafety, setProcessSafety] = useState([]);

  useEffect(()=> {
    if (companyLicense && companyLicense.length > 0)
    {
      console.log(companyLicense)
      const awareProV = companyLicense
      .filter((license) => license.game_name === "Life-Saving Rules Pro")
      .map((license) => ({
        game_name: license.game_name,
        license: license.license
      }));
      setAwarePro(awareProV)
    console.log("awarePro", awareProV)
    const awareRoadV = companyLicense
      .filter((license) => license.game_name === "Life-Saving Rules Road")
      .map((license) => ({
        game_name: license.game_name,
        license: license.license
      }));
      setAwareRoad(awareRoadV)
      console.log("awareRoad", awareRoadV)
    
    const awareAllRoadV = companyLicense
      .filter((license) => license.game_name === "Driving Aware All Roads")
      .map((license) => ({
        game_name: license.game_name,
        license: license.license
      }));
      setAwareAllRoad(awareAllRoadV)
      console.log("awareAll", awareAllRoadV)
    
    const drivingProGV = companyLicense
      .filter((license) => license.game_name === "Driving Pro Graded Road")
      .map((license) => ({
        game_name: license.game_name,
        license: license.license
      }));
      setDrivingProG(drivingProGV)
      console.log("dirivingpro", drivingProGV)
    
    const drivingBlackV = companyLicense
      .filter((license) => license.game_name === "Driving Pro Blacktop")
      .map((license) => ({
        game_name: license.game_name,
        license: license.license
      }));
      setDrivingBlack(drivingBlackV)
    console.log("driving blacktop", drivingBlackV)
    const awareRuleV = companyLicense
      .filter((license) => license.game_name === "Life-Saving Rules Aware")
      .map((license) => ({
        game_name: license.game_name,
        license: license.license
      }));
      setAwareRule(awareRuleV)
    
    const processSafetyV = companyLicense
      .filter((license) => license.game_name === "Process Safety")
      .map((license) => ({
        game_name: license.game_name,
        license: license.license
      }));
      setProcessSafety(processSafetyV)
    }

  }, [companyLicense])



  const handleInputChange = (game, value) => {
    setLicenses({
      ...licenses,
      [game]: parseInt(value) || 0,
    });
  };


//   const handleRenewChange = (game, isChecked) => {
//   setRenewSelection({
//     ...renewSelection,
//     [game]: isChecked ? 1 : 0, // 1 means selected, 0 means not selected
//   });
// };

  // handle pin submit

  // const handlePinSubmit = async (pin, game_name) => {
  //   try {
  //     // First API call to validate the PIN
  //     const response = await fetch('https://4o2xqh3rf3.execute-api.me-south-1.amazonaws.com/developed/pin_validation', {
  //       method: 'POST',
  //       mode: 'cors',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({ pin: pin, game_name: game_name }),
  //     });
  
  //     console.log(response);
  
  //     if (response.ok) {
  //       const urlResponse = await fetch('https://mcs024lkba.execute-api.me-south-1.amazonaws.com/developed/webgl_game_url', {
  //         method: 'GET',
  //         mode: 'cors',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       });
        
  //       console.log(urlResponse)
  //       if (urlResponse.ok) {
  //         const urlData = await urlResponse.json();
  //         const gameUrl = urlData.url; 
  //         console.log(gameUrl)
  //         window.open(gameUrl, '_blank');
  //       } else {
  //         console.error('Failed to fetch game URL');
  //       }
  //     } else {
  //       alert("Invalid Pin, Please enter the pin which was provided send to your email")
  //       console.error('PIN validation failed');
  //     }

  //   } catch (err) {
  //     console.error('Error occurred:', err.message);
  //     setError(err.message); 
  //   }
  // };





// charges calculation 
const prices = {
      "Life Saving Rules Aware": 10,
      "Life Saving Rules Pro": 30,
      "Life Saving Rules Road": 30,
      "Driving Aware All Roads": 15,
      "Driving Pro Blacktop": 25,
      "Driving Pro Graded Road": 30,
      "Process Safety": 50,
    };

  const calculateTotal = (selection) => {
    
      
      let total = Object.keys(selection).reduce(
        (sum, game) => sum + selection[game] * prices[game],
        0
      );
    

  const AwareBundle = [
      "Life-Saving Rules Aware",
      "Life-Saving Rules Pro",
      "Life-Saving Rules Road",
    ];

  const ProBundle = [
    "Driving Aware All Roads",
    "Driving Pro Blacktop",
    "Driving Pro Graded Road",
  ]
  

  const awareBundleCount = Math.min(
    ...AwareBundle.map((license) => selection[license] || 0)
  );

  const proBundleCount = Math.min(
    ...ProBundle.map((license) => selection[license] || 0)
  );


  let currentDiscount =0;

  if (awareBundleCount) 
    {
      currentDiscount += awareBundleCount * 10;
    }
    
  if (proBundleCount) 
    {
      console.log("reached here", proBundleCount)
      currentDiscount += proBundleCount * 5;
    }

    total -=currentDiscount

  return [total, currentDiscount];

};



// certificate download
  
  const handleCertificateDownload = (game) => {
    get_user_detail()
 
    console.log(game)
  
    const newWindow = window.open('', '', 'width=1024, height=1024');
    newWindow.document.title = "Certificate";
  
    const root = ReactDOM.createRoot(newWindow.document.body);  
    root.render(
      <Certificate recipientGivenName={givenName} recipientFamilyName={familyName} gameTitle={game[0]} date={game[1]} />
    );
  }

  
  useEffect (()=>{
    if (licenseData && licenseData.length > 0)
    {
    const pass_return = passedGames()
    setCompletedGames(pass_return)
    }
  }, [licenseData])


  const passedGames = () =>
  {
    if (licenseData && licenseData.length > 0){
      const passed_games = licenseData
      .filter((license) => {
      return license.pass === true || license.pass === 'true'; 
      }).map((license) => [license.game_name, license.pass_date]);


    return passed_games;
    }
  }


// ------------------------
  return (
    <div className="dashboard">
      <aside className="sidebar">
        <nav className="menu">
          <ul>
            <li> <img src="/virsatlogo.png" alt="Virsat Logo" className='image-align'/></li>
            <li><button onClick={() => setActivePage('purchase')}>Purchase PC License</button></li>
            {/* <li><button onClick={() => setActivePage('VRPurchase')}>Purchase VR License</button></li> */}
            {/* <li><button onClick={() => setActivePage('renew')}>Renew License</button></li> */}
            {/* <li><button onClick={() => setActivePage('play')}>Play Games</button></li> */}
            {/* <li><button onClick={() => setActivePage('certificates')}>My Certificates</button></li> */}
            <li><button onClick={() => setActivePage('licenses')}>My Licenses</button></li>
            <li><button onClick={() => setActivePage('share')}>Share Licenses</button></li>
            {/* <li><button onClick={() => setActivePage('help')}>Help</button></li> */}
            <li><button onClick={() => HandleSignOut()}>Sign Out</button></li>

            
          </ul>
        </nav>
      </aside>

      <main className="content">


  {activePage === 'purchase' && (

  <div className="purchase-form">

      <BusinessPage />
   </div> 

)}



        {/* Renew Section */}
        {/* {activePage === 'renew' && (
          <div className="renew-form">
            <h1>Renew Licenses</h1>
            {licenseData && licenseData.length> 0 ? (
              <form>
                {licenseData.map((license, index) => (
                  <div key={license.game_name} className="renew-group">
                    <div style={{ backgroundColor: `hsl(${index * 100}, 50%, 98%)` }}>

                    <label className="purchase-font">{license.game_name} </label>
                    <span className="purchase-right">${prices[license.game_name]}</span>

                    <input
                   type="checkbox"
                   checked={!!renewSelection[license.game_name]}
                   onChange={(e) => handleRenewChange(license.game_name, e.target.checked)}
                    />
                    </div>
                  </div>
                ))}
              </form>
            ) : (
              <p>No licenses available to renew.</p>
            )}
            <div className="total">
              <h3>Total: ${calculateTotal(renewSelection)[0]}</h3>
              <h5>Discount: ${calculateTotal(renewSelection)[1]}</h5>

            </div>
            <button onClick={() => alert('Proceeding to payment gateway...')}>Proceed to Payment</button>
          </div>
        )} */}

     


        {/* {activePage === 'certificates' && (
          <div className="certificates">
            <h1>My Certificates</h1>
            {completedGames.length > 0 ? (
              <ul>
                {completedGames.map((game, index) => (

                  <li className="certificate-padding" key={game}>
                    <div style={{ backgroundColor: `hsl(${index * 100}, 50%, 98%)` }}>

                   <div className='certificate-text'> {game[0]} </div><button className="certificate-margin" onClick={() => handleCertificateDownload(game)}>View Certificate</button>

                   </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No certificates available. Complete games to earn certificates.</p>
            )}
          </div>
        )} */}

{/* Help Section */}

 { activePage ==='help' && (
  
     <div className="help-section">
      <h1 className="title-blue">Help & Support</h1>
      {

         <ul className="help-list">
          <li>
          <h3 className='blue-text'>Purchase License as Individual</h3>
          </li>
           <li className="help-item">
             <span className="help-text">To access training and play the game, you need to purchase a license. To do so, visit the 'Purchase New License' section after logging into your account, and select the licenses you would like to purchase. Then click on Proceed with Payment to complete the transaction.</span>
            <img src="editedImages\IndividualPurchasecopy.jpg" alt="Purchase License" className="help-image" />
          
           </li>

            <li>
          <h3 className='blue-text'>Play Game</h3>
          </li>
           <li className="help-item">
             <span className="help-text">Once payment is processed, The purchased games start showing in the 'Game Play' section. Then you would have to provide the pin number that was sent to you in your email to start playing. </span>
          <img src="editedImages\PlayGamecopy.jpg" alt="Play Games" className="help-image" />
           </li>
            <li>
          <h3 className='blue-text'>License Status</h3>
          </li>
           <li className="help-item">
             <span className="help-text">Each license is valid for 30 days from the purchase date and allows 10 game plays. You can check your license status in the 'My Licenses' section.</span>
            <img src="editedImages\ViewLicensecopy.jpg" alt="License Status" className="help-image" />
           </li>
            <li>
          <h3 className='blue-text'>Renew License</h3>
          </li>
           <li className="help-item">
             <span className="help-text">If one or more of your licenses expire, you can renew them in the 'Renew License' section by selecting the expired license and proceed to payment.</span>
              <img src="editedImages\RenewLicensecopy.jpg" alt="Renew License" className="help-image" />
           </li>
          <li>
          <h3 className='blue-text'>Certificate</h3>
          </li>
           <li className="help-item">
             <span className="help-text">Upon completing the training and passing all required stages, a certificate will be issued to your name. You can download your certificate from the 'My Certificate' section.</span>
              <img src="editedImages\Certificatecopy.jpg" alt="Certificate" className="help-image" />
              {/* <img src="editedImages\DownloadedCertificatecopy.jpg" alt="Certificate" className="help-image-certificate" /> */}

           </li>
          
          <li>
          <h3 className='blue-text'>Purchase License as Business</h3>
          </li>
           <li className="help-item">
             <span className="help-text">As a business, you can purchase bulk licenses for your employees, and share these licenses with your employees</span>
          <img src="editedImages\BusinessPurchasecopy.jpg" alt="Bulk Purchase" className="help-image" />
           </li>

          <li>
          <h3 className='blue-text'>Share Licenses with Employees</h3>
          </li>
           <li className="help-item">
             <span className="help-text">Once you purchase licenses as a business. You can view the issued licenses in the 'Company License' section. Licenses can be sent to employees by just writing their email addresses against the license and click on send. If you have a long list of employees that you would like to send the licenses to. You can upload a csv file of email addresses and click on Send All Licenses</span>
              <img src="editedImages\ShareLicensescopy.jpg" alt="Share License" className="help-image" />
           </li>
           <li>
          <h3 className='blue-text'>Account Registeration for Employees</h3>
          </li>
           <li className="help-item">
             <span className="help-text">After receiving the license via email, users must create an account by going to login section.</span>
          <img src="editedImages\Registercopy.jpg" alt="Register Account" className="help-image" />
           </li>

           <li>
          <h3 className='blue-text'>Employee License Activation</h3>
          </li>
           <li className="help-item">
             <span className="help-text">After creating an account employees can activate their license in the 'Already Have a License' section of "Purchase New License". After activation, users can access the 'Play Games' section to start playing.</span>
              <img src="editedImages\ActivateLicensecopy.jpg" alt="Start Playing" className="help-image" />

           </li>
         </ul>
}
    </div>
)
}
{activePage ==='VRPurchase' && (
  <div className='VR-purchase'>
<VRPurchasePageBusiness />
{/* <ComingSoon /> */}
</div>
)}

   
     
        {/* Current Licenses */}

        


           

{activePage === 'licenses' && (
  <div className="licenses">
    <h1>My Licenses</h1>

    <div className="tab-container">
      <button
        className={`tab-button ${activeTab === 'pc' ? 'active' : ''}`}
        onClick={() => setActiveTab('pc')}
      >
        PC Licenses
      </button>

      {/* ------------------>VR license result */}
      {/* <button
        className={`tab-button ${activeTab === 'vr' ? 'active' : ''}`}
        onClick={() => setActiveTab('vr')}
      >
        VR Licenses
      </button> */}
    </div>
   

    {activeTab === 'pc' && (
      licenseData.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>Game Name</th>
              <th>Pin Code</th>
              <th>Games Run</th>
              <th>Expiration Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {(licenseData || []).map((extract_data) => (
              <tr key={extract_data.license}>
                <td className="game-name-bold">{extract_data.game_name}</td>
                <td>{extract_data.license}</td>
                <td style={{ color: extract_data.game_play < 1 ? 'red' : 'inherit' }}>
                  {extract_data.game_play}
                </td>
                <td style={{
                  color: new Date(extract_data.expiration_date) < new Date() ? 'red' : 'inherit',
                }}>
                  {extract_data.expiration_date}
                </td>
                <td style={{
                  color: extract_data.active ? 'green' : 'red',
                }}>
                  {extract_data.active ? 'Active' : 'InActive'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No active PC licenses. Purchase a license to get started.</p>
      )
    )}

{/* -------------------------> VR licneses */}
    {/* {activeTab === 'vr' && (
      VRLicenseData.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>Game Name</th>
              <th>Pin Code</th>
              <th>Games Run</th>
              <th>Expiration Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {(VRLicenseData || []).map((extract_data) => (
              <tr key={VRLicenseData.license}>
                <td className="game-name-bold">{extract_data.game_name}</td>
                <td>{extract_data.license}</td>
                <td style={{ color: extract_data.game_play < 1 ? 'red' : 'inherit' }}>
                  {extract_data.game_play}
                </td>
                <td style={{
                  color: new Date(extract_data.expiration_date) < new Date() ? 'red' : 'inherit',
                }}>
                  {extract_data.expiration_date}
                </td>
                <td style={{
                  color: extract_data.active ? 'green' : 'red',
                }}>
                  {extract_data.active ? 'Active' : 'InActive'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No active VR licenses. Purchase a license to get started.</p>
      )
    )} */}
  </div>
)}
          
           

           {/* Share license section */}
        {activePage === 'share' && (
          <div className="share-licenses">
            <h1>Share Licenses</h1>
            {companyLicense && companyLicense.length > 0 && drivingProG ? (
              <table className='share-table-design'>

                <thead>
                  <tr>
                    <th>Driving Pro Graded Road</th> 
                    <th>Enter Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {/* driving pro graded road */}
                  {drivingProG.map((license, index) => (
                  <tbody>
                    <tr  key={license.license}>
                      <td>{license.license}</td>
                    <td>
                    <input
                      type="email"
                      placeholder="Email"
                      value={emailLists["drivingProG"][index] || ""} 
                      onChange={(e) => handleEmailChange("drivingProG", index, e.target.value)}
                    />
                  </td>
                      <td><button onClick={() => handleSend(license.license, license.game_name, emailLists["drivingProG"][index])}>Send</button></td>
                    </tr>
                  </tbody>
                  ))}
            <tr>
              <td></td>
              <td>Upload CSV <input type="file" accept=".csv" onChange={(e) => handleCsvUpload(e, "drivingProG")} /></td>
              <td><button id="blue-button" onClick={() => handleSendAll(drivingProG, "drivingProG")}>Send All Licenses </button></td>
            </tr>
              </table>
            ) : (
              <p>No licenses available to share.</p>
            )}
            {/* section 2 */}
            {/* driving pro black top license */}
            {companyLicense && companyLicense.length > 0 && drivingBlack ?  (
              <table className='share-table-design'>

                <thead>
                  <tr>
                    <th>Driving Pro Blacktop</th>
                    <th>Enter Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                  {drivingBlack.map((license, index) => (
                    <tbody>

                    <tr key={license.name}>
                      <td>{license.license}</td>
                    <td>
                    <input
                      type="email"
                      placeholder="Email"
                      value={emailLists["drivingBlack"][index]} 
                      onChange={(e) => handleEmailChange("drivingBlack", index, e.target.value)}
                    />
                  </td>
                      <td><button onClick={() => handleSend(license.license, license.game_name, emailLists["drivingBlack"][index])}>Send</button></td>
                    </tr>
                  </tbody>
                  ))}
          <tbody>
            <tr>
              <td></td>
              <td>Upload CSV <input type="file" accept=".csv" onChange={(e) => handleCsvUpload(e, "drivingBlack")} /></td>
              <td><button id="blue-button" onClick={() => handleSendAll(drivingBlack, "drivingBlack")}>Send All Licenses</button></td>
            </tr>
          </tbody>
              </table>
            ) : (
              <p>No licenses available to share.</p>
            )}

            {/* section 3 */}
        {/* Life saving rules Pro */}
            {companyLicense && companyLicense.length > 0 && awarePro ? (
              <table className='share-table-design'>
                <thead>
                  <tr>
                    <th>Life-Saving Rules Pro</th>
                    <th>Enter Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {awarePro.map((license, index) => (
                    <tr key={license.name}>
                      <td>{license.license}</td>
                    <td>
                    <input className='input-share'
                      type="email"
                      placeholder="Email"
                      value={emailLists["awarePro"][index]} 
                      onChange={(e) => handleEmailChange("awarePro", index, e.target.value)}
                    />
                  </td>
                      <td><button onClick={() => handleSend(license.license, license.game_name, emailLists["awarePro"][index])}>Send</button></td>
                    </tr>
                  ))}
                </tbody>
          <tbody>
            <tr>
              <td></td>
              <td>Upload CSV <input type="file" accept=".csv" onChange={(e) => handleCsvUpload(e, "awarePro")} /></td>
              <td><button id="blue-button" onClick={() => handleSendAll(awarePro, "awarePro")}>Send All Licenses</button></td>
            </tr>
          </tbody>
              </table>
            ) : (
              <p>No licenses available to share.</p>
            )}
              {/* Section 4 */}
              {/*Aware Road */}
             {companyLicense && companyLicense.length > 0 && awareRoad  ? (
              <table className='share-table-design'>
                <thead>
                  <tr>
                    <th>Life-Saving Rules Road</th>
                    <th>Enter Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {awareRoad.map((license, index) => (
                    <tr key={license.name}>
                      <td>{license.license}</td>
                    <td>
                    <input
                      type="email"
                      placeholder="Email"
                      value={emailLists["awareRoad"][index]} 
                      onChange={(e) => handleEmailChange("awareRoad", index, e.target.value)}
                    />
                  </td>
                  <td><button onClick={() => handleSend(license.license, license.game_name, emailLists["awareRoad"][index])}>Send</button></td>
                  </tr>
                  ))}
                </tbody>
          <tbody>
            <tr>
              <td></td>
              <td>Upload CSV <input type="file" accept=".csv" onChange={(e) => handleCsvUpload(e, "awareRoad")} /></td>
              <td><button id="blue-button" onClick={() => handleSendAll(awareRoad, "awareRoad")}>Send All Licenses</button></td>
            </tr>
          </tbody>
              </table>
            ) : (
              <p>No licenses available to share.</p>
            )}
          {/* section 5 */}
          {/* Driving Aware All Roads */}
            {companyLicense && companyLicense.length > 0 && awareAllRoad ? (
              <table className='share-table-design'>
                <thead>
                  <tr>
                    <th>Driving Aware All Roads</th>
                    <th>Enter Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {awareAllRoad.map((license, index) => (
                    <tr key={license.name}>
                      <td>{license.license}</td>
                    <td>
                    <input
                      type="email"
                      placeholder="Email"
                      value={emailLists["awareAllRoad"][index]} 
                      onChange={(e) => handleEmailChange("awareAllRoad", index, e.target.value)}
                    />
                  </td>
                      <td><button onClick={() => handleSend(license.license, license.game_name, emailLists["awareAllRoad"][index])}>Send</button></td>
                    </tr>
                  ))}
                </tbody>
          <tbody>
            <tr>
              <td></td>
              <td>Upload CSV <input type="file" accept=".csv" onChange={(e) => handleCsvUpload(e, "awareAllRoad")} /></td>
              <td><button id="blue-button" onClick={() => handleSendAll(awareAllRoad, "awareAllRoad")}>Send All Licenses</button></td>
            </tr>
          </tbody>
              </table>
            ) : (
              <p>No licenses available to share.</p>
            )}
            {/* section 6 */}
            {/* Life Saving Rules Aware */}
            {companyLicense && companyLicense.length > 0 && aware ? (
              <table className='share-table-design'>
                <thead>
                  <tr>
                    <th>Life-Saving Rules Aware</th>
                    <th>Enter Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {aware.map((license, index) => (
                    <tr key={license.name}>
                      <td>{license.license}</td>
                    <td>
                    <input
                      type="email"
                      placeholder="Email"
                      value={emailLists["aware"][index] || ""} 
                      onChange={(e) => handleEmailChange("aware", index, e.target.value)}
                    />
                  </td>
                      <td><button onClick={() => handleSend(license.license, license.game_name, emailLists["aware"][index])}>Send</button></td>
                    </tr>
                  ))}
                </tbody>
          <tbody>
            <tr>
              <td></td>
              <td>Upload CSV <input type="file" accept=".csv" onChange={(e) => handleCsvUpload(e, "aware")} /></td>
              <td><button  id="blue-button" onClick={() => handleSendAll(aware, "aware")}>Send All Licenses</button></td>
            </tr>
          </tbody>

              </table>
              
            ) : (
              <p>No licenses available to share.</p>
            )}

            {/* section 7 */}

            {/* Process Safety */}
            {companyLicense && companyLicense.length > 0 && processSafety ? (
              <table className='share-table-design'>
                <thead>
                  <tr>
                    <th>Process Safety</th>
                    <th>Enter Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {processSafety.map((license, index) => (
                    <tr key={license.name}>
                      <td>{license.license}</td>
                    <td>
                    <input
                      type="email"
                      placeholder="Email"
                      value={emailLists["processSafety"][index]} 
                      onChange={(e) => handleEmailChange("processSafety", index, e.target.value)}
                    />
                  </td>
                      <td><button onClick={() => handleSend(license.license, license.game_name, emailLists["processSafety"][index])}>Send</button></td>
                    </tr>
                  ))}
                </tbody>
          <tbody>
            <tr>
              <td></td>
              
              <td>Upload CSV <input type="file" accept=".csv" onChange={(e) => handleCsvUpload(e, "processSafety")} /></td>
              <td><button id="blue-button" onClick={() => handleSendAll(processSafety, "processSafety")}>Send All Licenses</button></td>
            </tr>
          </tbody>
              </table>
            ) : (
              <p>No licenses available to share.</p>
            )}
          </div>
        )}
        <>
    </>
        {activePage !== 'purchase' && activePage !== 'renew' && activePage !== 'play' && activePage !== 'certificates' && activePage !== 'licenses' && activePage !=='share' && activePage !=='VRPurchase' && activePage !=='help' &&(
          <>
            <h1>Welcome to the Dashboard</h1>
   
            <p>Select an option from the menu to get started.</p>
          </>
        )}
      </main>
    </div>
  );


};

export default withAuthenticator(Dashboard);